// extracted by mini-css-extract-plugin
export default {"comment":"social-sections-RepostSection__comment--17aBN"};